<template>
  <v-dialog
    v-model="modalAdduser"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Ajouter un utilisateur</span>
      </v-card-title>
      <v-card-text v-if="modalAdduser">
        <v-container>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md12
                >
                  <v-switch
                    v-model="newuser.proprietaire"
                    color="primary"
                    label="Propriétaire"/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newuser.nom"
                    class="purple-input"
                    label="Nom"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newuser.prenom"
                    class="purple-input"
                    label="Prénom"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newuser.courriel"
                    :rules="[rules.required, rules.email]"
                    label="Courriel"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newuser.password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    name="input-10-1"
                    label="Mot de passe"
                    hint="Au moins 8 caractères"
                    counter
                    @click:append="show = !show"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newuser.adresse"
                    label="Adresse"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newuser.ville"
                    label="Ville"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    v-model="newuser.departement"
                    label="Département"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    v-model="newuser.codepostal"
                    class="purple-input"
                    label="Code postal"
                    type="number"/>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="newuser.notes"
                    class="purple-input"
                    label="Notes"
                    value=""/>
                </v-flex>
                <v-flex
                  xs12
                  text-right
                />
              </v-layout>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="warning darken-1"
          text
          @click="closeModal('Adduser')">Annuler</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="addUser()">Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import { auth, db } from '@/plugins/firebase'
import moment from 'moment'

export default {
  data: () => ({
    show: false,
    invalidlog: false,
    newuser: {
      proprietaire: false,
      nom: '',
      prenom: '',
      courriel: '',
      password: '',
      adresse: '',
      ville: '',
      departement: '',
      codepostal: '',
      notes: ''
    },
    rules: {
      required: value => !!value || 'Champs requis.',
      min: v => v.length >= 8 || 'Min 8 caractères',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Courriel invalide.'
      }
    }
  }),
  computed: {
    ...mapGetters(['modalAdduser'])
  },
  methods: {
    ...mapActions(['closeModal']),
    addUser (newuser) { // <-- and here
      const informations = this.newuser
      informations.inscription = moment().format('DD MM YYYY')
      auth.createUserWithEmailAndPassword(informations.courriel, informations.password)
        .then(data => {
          db.collection('utilisateurs').doc(data.user.uid).set(informations)
          this.newuser = {
            proprietaire: false,
            nom: '',
            prenom: '',
            courriel: '',
            password: '',
            adresse: '',
            ville: '',
            departement: '',
            codepostal: '',
            notes: ''
          }
          this.closeModal('Adduser')
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
